import image1Path from "../../../assets/backgrounds/BG1.jpg"
import image2Path from "../../../assets/backgrounds/BG2.jpg"
import image3Path from "../../../assets/backgrounds/BG3.jpg"

export default [
    {
        description: "_Die schalloptimierende Wirkung unserer Absorber hängt vor allem vom Volumen und Gesamtoberfläche ab, weniger von der Optik. Sie können also ganz nach Ihrem Geschmack entscheiden.",
        name: "_Elaubt ist was gefällt",
        imagePath: image1Path,
    },
    {
        description: "Je mehr Absorber in einem Raum hängen, desto mehr wird der Nachhall reduziert. Abe einer Absorberfläche von 10% der Raumoberfläche tritt ein hörbarer Effekt ein. Alle unsere Vorschläge erfüllen diese Anforderung.",
        name: "Viel hilft viel",
        imagePath: image2Path,
    },
    {
        description: "Decke, Wände oder Boden - Schall nutzt jede glatte Oberfläche zur Reflektion. Seien Sie kreativ und nutzen Sie unser breites Sortiment ganz wie es Ihnen gefällt.",
        name: "Think outside the box",
        imagePath: image3Path,
    },
]
